import * as React from "react";
import { BreadCrumbsConstants } from "../../models/constants/breadcrumbs.constants";
import BreadCrumbs from "../../presentations/BreadCrumbs";

const BreadCrumbsContainer = () => {
  return (
    <div>
      <BreadCrumbs routes={BreadCrumbsConstants.Routes}></BreadCrumbs>
    </div>
  );
};

export default BreadCrumbsContainer;
